import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {ContracteeRegion} from '@models/contractee-region.interface';
import {buildPath} from '@utils/util-builder';
import {ApiResponse} from '@models/api.response';

@Injectable({
    providedIn: 'root'
})
export class ContracteeRegionService {
    private readonly _basePath: string = 'data-core/contractee-regions';

    constructor(private readonly _http: HttpClient) {
    }

    getContracteeRegions(contracteeId: number): Observable<ContracteeRegion[]> {
        const url: string = buildPath([this._basePath, contracteeId.toString()]);
        return this._http.get<ApiResponse<ContracteeRegion[]>>(url).pipe(
            map((response: ApiResponse<ContracteeRegion[]>): ContracteeRegion[] => response.data)
        );
    }

    createContracteeRegion(region: ContracteeRegion): Observable<ContracteeRegion> {
        const url: string = buildPath([this._basePath]);
        return this._http.post<ApiResponse<ContracteeRegion>>(url, region).pipe(
            map((response: ApiResponse<ContracteeRegion>): ContracteeRegion => response.data)
        );
    }

    updateContracteeRegion(region: ContracteeRegion): Observable<ContracteeRegion> {
        const url: string = buildPath([this._basePath, region.id.toString()]);
        return this._http.put<ApiResponse<ContracteeRegion>>(url, region).pipe(
            map((response: ApiResponse<ContracteeRegion>): ContracteeRegion => response.data)
        );
    }

    deleteContracteeRegion(id: number): Observable<void> {
        const url: string = buildPath([this._basePath, id.toString()]);
        return this._http.delete<ApiResponse<void>>(url).pipe(
            map((response: ApiResponse<void>): void => response.data)
        );
    }
}
